"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitStringForTemperatureUnit = void 0;
const TemperatureUnit_1 = require("./TemperatureUnit");
function unitStringForTemperatureUnit(variableName) {
    switch (variableName) {
        case TemperatureUnit_1.TemperatureUnit.Celsius:
            return '°C';
        case TemperatureUnit_1.TemperatureUnit.Fahrenheit:
            return '°F';
        case TemperatureUnit_1.TemperatureUnit.kelvin:
            return 'K';
    }
}
exports.unitStringForTemperatureUnit = unitStringForTemperatureUnit;
//# sourceMappingURL=unitStringForTemperatureUnit.js.map